<template>
  <div class="YiDong">
    <!-- 夏季：6-8月 -->
    <div class="summer" v-if="nowMoth >= 6 && nowMoth <= 8">
      <div class="banner">
        <img width="100%" src="../../../assets/img/YiDong/summer_banner.jpg" alt="" srcset="">
      </div>
      <div class="con1">
        <div class="con1_leftBox">
          <img width="100%" src="../../../assets/img/YiDong/summer_huajiaoPic.png" alt="" srcset="">
        </div>
        <div class="con1_rightBox">
          <div class="top_title">
            <div style="display: flex;justify-content: center;align-items: center;">
              <img style="margin-right:5px;" src="../../../assets/img/YiDong/summer_square.png" alt="" srcset="">
              <span>简介</span>
            </div>
            <!-- <span style="display:block">>></span> -->
          </div>
          <div class="cont">
            <p>
              据宜东镇相关负责人介绍，种植户们常年坚持使用农家肥、科学种植农作物，有效保证了品质，口感到位同时农作物也很健康。
            </p>
            <div style="width:100%;margin-top:10px;">
              <img style="width:100%;float:right;" src="../../../assets/img/YiDong/summer_jianjiePic.png" alt="">
            </div>
          </div>
        </div>
      </div>
      <!-- 便民 -->
      <!-- <ConvenientService :matterList="matterList" :mapId="mapId" :name="name" :imgSrc="require('../../../assets/img/YiDong/summer_square.png')"
        color="#394C9F" borderBottomColor="#394C9F" boxBorderColor="#C7C8D3" btnBJcolor="#8F9AC8" hoverBJcolor="#203594">
      </ConvenientService> -->
      <GovernmentServices :mapId="mapId" :name="name" :imgSrc="require('../../../assets/img/YiDong/summer_square.png')"
        color="#394C9F" borderBottomColor="#394C9F"></GovernmentServices>
      <!-- 直通乡镇 -->
      <ztxzList :villages="villages" :imgSrc="require('../../../assets/img/YiDong/summer_square.png')" color="#394C9F"
        borderBottomColor="#394C9F" boxBorderColor="#C7C8D3"></ztxzList>
    </div>
    <!-- 秋季：9-11月 -->
    <div class="autumn" v-else-if="nowMoth >= 9 && nowMoth <= 11">
      <div class="banner">
        <img width="100%" src="../../../assets/img/YiDong/autumn_banner.jpg" alt="" srcset="">
      </div>
      <div class="con1">
        <div class="con1_leftBox">
          <img width="100%" src="../../../assets/img/YiDong/autumn_pingguoPic.png" alt="" srcset="">
        </div>
        <div class="con1_rightBox">
          <div class="top_title">
            <div style="display: flex;justify-content: center;align-items: center;">
              <img style="margin-right:5px;" src="../../../assets/img/YiDong/autumn_square.png" alt="" srcset="">
              <span>简介</span>
            </div>
            <!-- <span style="display:block">>></span> -->
          </div>
          <div class="cont">
            <p>
              糖心苹果果核透明、果香浓郁、甘甜味厚、多汁无渣、果肉细腻，是一种蕴含了丰富的维生素C、纤维素、胡萝卜素、果胶等营养元素的水果。
            </p>
            <p>
              宜东镇是汉源县糖心苹果最具代表性的质量最高的产地，主要分布在三江村、大树村、永定村、林政村、新林村、海亭村六个村，我镇独特的光热资源和温差较大的气候特点，为糖心苹果的生长提供了极佳的自然条件，使苹果内产生糖分自然凝聚现象，故而形成糖心，经测试糖度高达16.7°。
            </p>
            <p>
              糖心苹果口感甜润清脆、肉质细腻、口味甘甜、外形红润美观，咀嚼后没有渣滓，糖心苹果口感好主要是因为昼夜温差大，采摘时间晚，糖分积累更多，因此口感甜润清脆、可口美味。而普通苹果：果肉结构比较松散、水分丰富，但是甜度不佳，咀嚼后有渣滓。所以相比而言糖心苹果一直深受广大消费者的喜爱。
            </p>
            <div style="width:100%;margin-top:10px;">
              <img style="width:100%;float:right;" src="../../../assets/img/YiDong/autumn_jianjiePic.png" alt="">
            </div>
          </div>
        </div>
      </div>
      <!-- 便民 -->
      <!-- <ConvenientService :matterList="matterList" :mapId="mapId" :name="name" :imgSrc="require('../../../assets/img/YiDong/autumn_square.png')"
        color="#AC150C" borderBottomColor="#AC150C" boxBorderColor="#D7C7C8" btnBJcolor="#D48D87" hoverBJcolor="#B02118">
      </ConvenientService> -->
      <GovernmentServices :mapId="mapId" :name="name" :imgSrc="require('../../../assets/img/YiDong/autumn_square.png')"
        color="#AC150C" borderBottomColor="#AC150C"></GovernmentServices>
      <!-- 直通乡镇 -->
      <ztxzList :villages="villages" :imgSrc="require('../../../assets/img/YiDong/autumn_square.png')" color="#AC150C"
        borderBottomColor="#AC150C" boxBorderColor="#D7C7C8"></ztxzList>
    </div>
    <!-- 冬季：1、2、12月 -->
    <div class="winter" v-else-if="(nowMoth >= 1 && nowMoth <= 2) || nowMoth==12">
      <div class="banner">
        <img width="100%" src="../../../assets/img/YiDong/winter_banner.jpg" alt="" srcset="">
      </div>
      <div class="con1">
        <div class="con1_leftBox">
          <img width="100%" src="../../../assets/img/YiDong/winter_shibingPic.png" alt="" srcset="">
        </div>
        <div class="con1_rightBox">
          <div class="top_title">
            <div style="display: flex;justify-content: center;align-items: center;">
              <img style="margin-right:5px;" src="../../../assets/img/YiDong/winter_square.png" alt="" srcset="">
              <span>简介</span>
            </div>
            <!-- <span style="display:block">>></span> -->
          </div>
          <div class="cont">
            <p>
              坛子肉，是我县特产，中国国家地理标志产品。坛子肉源起于宜东，因宜东古来便是茶马古道重要驿站，气候宜人，空气湿度较低，冬春干旱无严寒，夏秋多雨无酷热，适宜坛子肉保存，使得坛子肉具有存放1年而不变质的特点，从古至今，人们便将坛子肉作为肉熟制品保存的主要途径。坛子肉制作工艺用：选、腌、洗、炸、捞、贮6个字概括，精选猪肉修割好后放盐拌和均匀腌制24小时，腌制好后用清水漂洗干净，将猪板油放入大锅内炼制出油后放入清洗干净的猪肉，大火炸至猪肉成黄色后改用小火慢炸，直至猪肉表面呈金黄色后停止加热，最后将炸制好的猪肉放入消毒后的陶罐内，并将猪油一并倒入陶罐内至淹没肉块为止。整套生产流程无添加剂、不进行熏烤，最大程度保留了坛子肉的原汁原味。
            </p>
            <p>柿饼，中药名。为柿科植物柿的果实经加工而成的饼状食品，有白柿、乌柿两种。入药部位植物果实。炮制方法取成熟的柿子，削去外皮，日晒夜露，约经一月后，放置席圈内，再经一月左右，即成柿饼。</p>
          </div>
        </div>
      </div>
      <!-- 便民 -->
      <!-- <ConvenientService :matterList="matterList" :mapId="mapId" :name="name" :imgSrc="require('../../../assets/img/YiDong/winter_square.png')"
        color="#AC150C" borderBottomColor="#AC150C" boxBorderColor="#D7C7C8" btnBJcolor="#D48D87" hoverBJcolor="#B02118">
      </ConvenientService> -->
      <GovernmentServices :mapId="mapId" :name="name" :imgSrc="require('../../../assets/img/YiDong/winter_square.png')"
        color="#AC150C" borderBottomColor="#AC150C"></GovernmentServices>
      <!-- 直通乡镇 -->
      <ztxzList :villages="villages" :imgSrc="require('../../../assets/img/YiDong/winter_square.png')" color="#AC150C"
        borderBottomColor="#AC150C" boxBorderColor="#D7C7C8"></ztxzList>
    </div>
    <!--四季-->
    <div class="spring" v-else>
      <div class="banner">
        <img width="100%" src="../../../assets/img/YiDong/banner.jpg" alt="" srcset="">
      </div>
      <div class="con1">
        <div class="con1_leftBox">
          <img width="100%" src="../../../assets/img/YiDong/tantanrouPic.png" alt="" srcset="">
        </div>
        <div class="con1_rightBox">
          <div class="top_title">
            <div style="display: flex;justify-content: center;align-items: center;">
              <img style="margin-right:5px;" src="../../../assets/img/YiDong/square.png" alt="" srcset="">
              <span>简介</span>
            </div>
            <!-- <span style="display:block">>></span> -->
          </div>
          <div class="cont">
            <p style="line-height: 28px;">
              坛子肉，是我县特产，中国国家地理标志产品。坛子肉源起于宜东，因宜东古来便是茶马古道重要驿站，气候宜人，空气湿度较低，冬春干旱无严寒，夏秋多雨无酷热，适宜坛子肉保存，使得坛子肉具有存放1年而不变质的特点，从古至今，人们便将坛子肉作为肉熟制品保存的主要途径。坛子肉制作工艺用：选、腌、洗、炸、捞、贮6个字概括，精选猪肉修割好后放盐拌和均匀腌制24小时，腌制好后用清水漂洗干净，将猪板油放入大锅内炼制出油后放入清洗干净的猪肉，大火炸至猪肉成黄色后改用小火慢炸，直至猪肉表面呈金黄色后停止加热，最后将炸制好的猪肉放入消毒后的陶罐内，并将猪油一并倒入陶罐内至淹没肉块为止。整套生产流程无添加剂、不进行熏烤，最大程度保留了坛子肉的原汁原味。
            </p>
            <div style="width:100%;margin-top:10px;">
              <img style="width:100%;float:right;" src="../../../assets/img/YiDong/jianjiePic.png" alt="">
            </div>
          </div>
        </div>
      </div>
      <!-- 便民 -->
      <!-- <ConvenientService :matterList="matterList" :mapId="mapId" :name="name" :imgSrc="require('../../../assets/img/YiDong/square.png')"
        color="#AC150C" borderBottomColor="#AC150C" boxBorderColor="#D7C7C8" btnBJcolor="#D48D87" hoverBJcolor="#B02118">
      </ConvenientService> -->
      <GovernmentServices :mapId="mapId" :name="name" :imgSrc="require('../../../assets/img/YiDong/square.png')"
        color="#AC150C" borderBottomColor="#AC150C"></GovernmentServices>
      <!-- 直通乡镇 -->
      <ztxzList :villages="villages" :imgSrc="require('../../../assets/img/YiDong/square.png')" color="#AC150C"
        borderBottomColor="#AC150C" boxBorderColor="#D7C7C8"></ztxzList>
    </div>
  </div>
</template>
<script>
import ztxzList from "@/components/ztxzList/index";
import ConvenientService from "@/components/ConvenientService/index";
import GovernmentServices from "@/components/GovernmentServices/index";
import { getServerDate, matterQuery } from "@/api/map/index"
import { mixin } from "../../../mixin";
export default {
  name: 'YiDong',
  components: { ztxzList, ConvenientService,GovernmentServices },
  data() {
    return {
      nowMoth: null, //当前月份
      mapId: this.$route.params.mapId || null,  //点位ID
      matterList: [],  //事项列表
      villages: [],  //乡镇列表
      name:'宜东镇'
    };
  },
  mixins:[mixin],
  created() {
    this.$emit('public_header', false);

  },
  // mounted() {
  //   // if (this.$route.params.mapId) {
  //   //   sessionStorage.setItem('mapId', this.mapId)
  //   // }
  //   // if (sessionStorage.getItem('mapId')) {
  //   //   this.mapId = sessionStorage.getItem('mapId');
  //   // }
  //   this.getData()
  //   this.getMatterList()
  // },

  // methods: {
  //   // 获取服务器当前时间
  //   getData() {
  //     getServerDate().then(res => {
  //       // console.log(res,'时间')
  //       if (res.data.code == 200) {
  //         this.FormatData(res.data.data)
  //       }
  //     })
  //   },
  //   // 获取便民办事
  //   getMatterList() {
  //     let query = {
  //       id: this.mapId
  //     }
  //     matterQuery(query).then(res => {
  //       // console.log(res,'事项列表')
  //       if (res.data.code == 200) {
  //         if (res.data.rows && res.data.rows.length > 0) {
  //           this.matterList = res.data.rows.slice(0, 5);
  //         } else {
  //           // this.$message.error('暂无事项！')
  //           console.log('暂无事项')
  //         }
  //       } else {
  //         this.$message.error('事项列表获取失败！')
  //       }
  //     })
  //   },
  //   // 日期时间格式化
  //   // 日期时间格式化
  //   FormatData(n) {
  //     // console.log(n, '时间')
  //     let now = new Date(n),
  //       // y = now.getFullYear();
  //       m = now.getMonth() + 1;
  //     // d = now.getDate();
  //     // return y + "-" + (m < 10 ? "0" + m : m) + "-" + (d < 10 ? "0" + d : d) + " " + now.toTimeString().substr(0, 8);
  //     this.nowMoth = m;
  //   },
  // },
};
</script>
<style scoped>
.YiDong {
  background: url('../../../../src/assets/img/YiDong/bg.png');
  background-size: 100% 100%;
}

.banner {
  width: 100%;
}

.con1 {
  width: 1200px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  margin-top: 20px;
}

.con1 .con1_leftBox,
.con1 .con1_rightBox {
  width: 49%;
}

.con1 .con1_rightBox .cont {
  text-align: left;
  text-indent: 2em;
  margin: 10px 0;
  height: 83%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.spring .top_title {
  color: #AC150C;
  font-size: 25px;
  font-weight: bold;
  display: flex;
  justify-content: space-between;
  border-bottom: 2px solid #AC150C;
  height: 12%;
}

.summer .top_title {
  color: #394C9F;
  font-size: 25px;
  font-weight: bold;
  display: flex;
  justify-content: space-between;
  border-bottom: 2px solid #394C9F;
  height: 12%;
}

.autumn .top_title {
  color: #AC150C;
  font-size: 25px;
  font-weight: bold;
  display: flex;
  justify-content: space-between;
  border-bottom: 2px solid #AC150C;
  height: 12%;
}

.winter .top_title {
  color: #AC0D0A;
  font-size: 25px;
  font-weight: bold;
  display: flex;
  justify-content: space-between;
  border-bottom: 2px solid #AC0D0A;
  height: 12%;
}

.con2 {
  width: 1200px;
  margin: 0 auto;
  margin-top: 25px
}

.list_item {
  background-color: #F9F9F9;
  border-radius: 10px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 78px;
  padding: 0 10px;
  border: 1px solid #EBA970;
  margin-bottom: 20px;
}

.list_item_left {
  font-size: 18px;
  font-weight: bold;
}

.banshi_btn {
  background-color: rgb(234, 182, 134);
  color: rgb(255, 255, 255);
  border: none;
  font-size: 18px;
  font-weight: bold;
  border-radius: 7px;
}

.banshi_btn:hover {
  background-color: #DB7312;
}

.ztxz {
  width: 1200px;
  margin: 0 auto;
  margin-top: 25px
}

.xzlist {
  margin: 20px 0;
  background-color: #F9F9F9;
  border: 1px solid #EBA970;
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
  align-items: center;
  height: 100px;
  padding: 0 20px;
}

.xzlist a {
  display: inline-block;
  margin-right: 40px;
  font-size: 16px;
  font-weight: 550;
}
</style>